import { Point2D as Point2DInterface } from '@paragon/contract-library';
import { angleEquals, Direction2D, Point2D, Vector2D } from '@paragon/geometry-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

export type CardinalDirection = 'up' | 'down' | 'left' | 'right';

export function invertDirection(direction: CardinalDirection): CardinalDirection {
  switch (direction) {
    case 'up':
      return 'down';

    case 'down':
      return 'up';

    case 'left':
      return 'right';

    case 'right':
      return 'left';

    default:
      assertExhaustiveSwitch(direction);
  }
}

export interface PointMovement {
  readonly direction: CardinalDirection;
  readonly distance: number;
}

export function movePointInDirection(
  point: Point2DInterface,
  { direction, distance }: PointMovement,
): Point2DInterface {
  return Point2D.fromObject(point).translate(Direction2D[direction].toVector(distance)).toObject();
}

export function angleToDirection(angle: number): CardinalDirection | null {
  angle = (angle + 360) % 360;

  if (angleEquals(angle, 0)) return 'right';
  if (angleEquals(angle, 90)) return 'up';
  if (angleEquals(angle, 180)) return 'left';
  if (angleEquals(angle, 270)) return 'down';

  return null;
}

export function keyboardCodeToDirection(code: KeyboardEvent['code']) {
  switch (code) {
    case 'ArrowUp':
      return 'up';

    case 'ArrowDown':
      return 'down';

    case 'ArrowLeft':
      return 'left';

    case 'ArrowRight':
      return 'right';

    default:
      return null;
  }
}

export function vectorIsPointingInDirection(vector: Vector2D, direction: CardinalDirection) {
  switch (direction) {
    case 'up':
      return vector.y > 0;

    case 'down':
      return vector.y < 0;

    case 'left':
      return vector.x < 0;

    case 'right':
      return vector.x > 0;

    default:
      assertExhaustiveSwitch(direction);
  }
}
